import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CatchHandler } from "../utils/catchHandler.util";
import { PoMenuItem } from "@po-ui/ng-components";
import { LocalStorageType } from "../types/localStorage.type";
import { firstValueFrom } from "rxjs";
import { environment } from "../environments/environment";
import { GlobalService } from "./global.service";

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    constructor(
        private http: HttpClient,
        private catchHandler: CatchHandler,
        private globalService: GlobalService
    ) {

    }

    private menuEndpoint: string = 'api/totvsmoda/internal/management/v2/menu';

    get apiHost(): string {
        return this.globalService.getClientHost() || environment.API_URL;
    }

    public async getMenu(): Promise<Array<PoMenuItem>> {
        const sessionStoregeMenu = localStorage.getItem(LocalStorageType.Menu);

        if (sessionStoregeMenu !== null) {
            return this.getMenuFromSessionStorage(sessionStoregeMenu);
        }

        return this.getNewMenu();
    }

    private async getNewMenu(): Promise<Array<PoMenuItem>> {
        let menu: Array<PoMenuItem> = [];

        const request = this.http.get<Array<PoMenuItem>>(
            this.apiHost + this.menuEndpoint,
        );

        return await firstValueFrom(request)
            .then((res) => {
                menu = res as Array<PoMenuItem>;
                const stringfiedMenu = JSON.stringify(menu!);

                localStorage.setItem(LocalStorageType.Menu, stringfiedMenu);

                return menu;
            })
            .catch((err) => {
                this.catchHandler.handle(err);
                return [];
            });
    }

    private async getMenuFromSessionStorage(sessionStorageMenu: string): Promise<Array<PoMenuItem>> {
        const menu = JSON.parse(sessionStorageMenu!);

        return new Promise<Array<PoMenuItem>>((resolve) => { resolve(menu); });
    }
}